(() => {
  // ====== CONFIG ======
  const BAIT_VARIANT_ID = 43547290501185; // Soft Dad
  const FREE_SHIRT_VARIANTS = {
    S:  43547309473857,
    M:  43547309506625,
    L:  43547309539393,
    XL: 43547309572161,
    "2XL": 43547309604929,
  };

  const FREE_SHIRT_IDS = Object.values(FREE_SHIRT_VARIANTS);
  const SYNC_DELAY_MS = 300;

  let syncTimer = null;
  let syncing = false;

  // ====== HELPERS ======
  async function fetchCart() {
    const res = await fetch("/cart.js", { cache: "no-store" });
    return res.json();
  }

  function hasBait(cart) {
    return cart.items.some(i => i.variant_id === BAIT_VARIANT_ID);
  }

  function getFreeShirtItem(cart) {
    return cart.items.find(i => FREE_SHIRT_IDS.includes(i.variant_id));
  }

  async function addShirt(variantId) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
  }

  async function removeShirt(key) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify([{ id: key, quantity: 0 }])
    });
  }

  // ====== MODAL ======
  function openGiftModal() {
    const modal = document.getElementById("gift-size-modal");
    const container = document.getElementById("gift-size-container");
    const subtitle = document.getElementById("gift-modal-subtitle");

    container.innerHTML = "";
    subtitle.textContent = "Choose your free shirt size";

    // ⭐ Add your message
    const note = document.createElement("div");
    note.style.margin = "8px 0 12px 0";
    note.style.fontSize = "14px";
    note.style.color = "#666";
    note.textContent = "One free shirt per order.";
    subtitle.insertAdjacentElement("afterend", note);

    // Size selector
    const row = document.createElement("div");
    row.className = "gift-size-row";
    row.innerHTML = `
      <label>Shirt Size</label>
      <select id="gift-size-select">
        ${Object.keys(FREE_SHIRT_VARIANTS)
          .map(size => `<option value="${size}">${size}</option>`)
          .join("")}
      </select>
    `;
    container.appendChild(row);

    modal.classList.remove("hidden");
  }

  function closeGiftModal() {
    document.getElementById("gift-size-modal").classList.add("hidden");
  }

  async function handleGiftConfirm() {
    const size = document.getElementById("gift-size-select").value;
    const variantId = FREE_SHIRT_VARIANTS[size];
    await addShirt(variantId);
    closeGiftModal();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.getElementById("gift-size-confirm").addEventListener("click", handleGiftConfirm);
  });

  // ====== MAIN LOGIC ======
  async function enforceGiftRules() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await fetchCart();
      const baitPresent = hasBait(cart);
      const shirtItem = getFreeShirtItem(cart);

      // If bait exists but no shirt → show modal
      if (baitPresent && !shirtItem) {
        openGiftModal();
        syncing = false;
        return;
      }

      // If no bait but shirt exists → remove shirt
      if (!baitPresent && shirtItem) {
        await removeShirt(shirtItem.key);
      }

    } catch (err) {
      console.warn("[gift-shirt] error:", err);
    }

    syncing = false;
  }

  function schedule() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(enforceGiftRules, SYNC_DELAY_MS);
  }

  // ====== FETCH OVERRIDE ======
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    const url = args[0];

    if (typeof url === "string" && (
      url.includes("/cart/add") ||
      url.includes("/cart/add.js") ||
      url.includes("/cart/update") ||
      url.includes("/cart/update.js") ||
      url.includes("/cart/change") ||
      url.includes("/cart/change.js")
    )) {
      schedule();
    }

    return res;
  };

  // ====== DAWN DRAWER RERENDER ======
  document.addEventListener("cart:updated", () => {
    schedule();
  });

  document.addEventListener("DOMContentLoaded", () => {
    schedule();
  });

})();
